import { addDesignOnCanvas, closeOptions } from "./personalized-services-tool";

let searchInput;

$(document).ready(function() {
    let searchInputTimeout;

    //Searching
    $('.search-input-personalized').keyup(function() {
        $(".number-of-results").closest('.number-results-container').css('visibility', 'hidden');

        if ($(this).val() != '') {
            $(".row .container-input-tool-search .remove-search-text").show();
        }

        searchInput = $(this);
        clearTimeout(searchInputTimeout);
        searchInputTimeout = setTimeout(function(){
            if (searchInput.val() != "") {
                searchDesign(searchInput.val());
            }
        }, 500);
    });

    //Hide iconText by Delete key
    $(document).on('keyup' ,function(e) {
        if (e.which == 8) {
            if ($('.search-input-personalized').val() == '') {
                $(".row .container-input-tool-search .remove-search-text").hide();
            }
        }
    });

    //Add Design to canvas
    $('body').on('click', '.design-element', function () {
        let image = $(this).find('.addDesign').attr('data-url');
        addDesignOnCanvas(image);
        let maxWidthMobile = '992';
        let widthDevice =  $(window).width();
        if (widthDevice < maxWidthMobile) {
            let divOption = $('#options-search');
            closeOptions(divOption);
            $('.search-input-personalized').val('');
            $(".results-search").html('');
        }
    });

    //Remove text input search
    $(".row .container-input-tool-search .remove-search-text").click(function(e) {
        $(this).hide();
        $(".search-input-personalized").val('');
        $(".results-tool-search").html('');
    });

    //Send by Search Button
    $('.row .container-input-tool-search .executeSearchButton').click(function () {
        if (!$('.search-input-personalized').val()) {
            $('.container-input-tool-search').addClass('empty');
            setTimeout(() => {  $('.container-input-search').removeClass('empty'); }, 2000);
        } else if (searchInput && searchInput.val() != "") {
            searchDesign(searchInput.val());
            $(".row .container-input-tool-search .remove-search-text").hide();
        }
    });

    //Send by Enter key
    $(document).on('keypress',function(e) {
        if (e.which == 13) {
            if (searchInput && searchInput.is(":focus") && searchInput.val() != "") {
                searchDesign(searchInput.val());
                $(".row .container-input-tool-search .remove-search-text").hide();
            } else {
                $('.container-input-tool-search').addClass('empty');
                setTimeout(() => {  $('.container-input-search').removeClass('empty'); }, 200);
            }
        }
    });

    $(document).on('click', '.loadMoreDesigns', function() {
        searchDesign(searchInput.val(), $(this).data('page'));
    });
});

function loadDefaultInformation()
{
    $(".container-tool-results").removeClass('loader-show');

    if (ajaxSearchSend) {
        ajaxSearchSend.abort();
    }
}

let ajaxToolSearchSend = null;

function searchDesign(search, page)
{
    if (search.length < 3) {
        return;
    }
    page = (page === undefined) ? 1 : page;
    if (page === 1) {
        $('.message-search-empty').hide();
        $('.container-results-tool-search').show();
        $('.loader-tool-search').show();
        $('.results-tool-search').fadeOut();
    }
    if (ajaxToolSearchSend) {
        ajaxToolSearchSend.abort();
    }
    $('.message-search-empty').hide();
    $(".message-error-search").hide();
    ajaxToolSearchSend = $.post(
        '/ajax/personalized_services/search_designs',
        {
            search: search,
            page: page
        },
        function(data) {
            $('.loader-tool-search').hide();
            if (data.elasticsearchDown) {
                $(".message-error-search p").text(data.errorMessage || 'hhj');
                $(".message-error-search").show();
            } else if (data.html.length) {
                if (page === 1) {
                    $('.container-results-tool-search').hide();
                    $('.results-tool-search').html(data.html).fadeIn(200);
                } else {
                    $('.results-tool-search .more-designs-' + page).html(data.html);
                }
            } else {
                $('.message-search-empty p').text(data.emptySearchMessage || '');
                $('.message-search-empty').show();
            }
        }
    );
}